module.exports = __webpack_public_path__ + "static/media/coro_pacini.cb1a35ec.jpg";